import React from 'react';
import { Box } from '../../../../../../../CommonComponents/OPL/Box/Box';
import { EmptyState } from '../../../../../../../CommonComponents/OPL/AsyncStates/EmptyState/EmptyState';

export const PositionsDetailsEmpty: React.FC = () => {
  return (
    <tbody>
      <tr style={{ borderBottom: 'none' }}>
        <td colSpan={8}>
          <Box p="56" bg="bg">
            <EmptyState />
          </Box>
        </td>
      </tr>
    </tbody>
  );
};
